import { render, staticRenderFns } from "./PictureView.vue?vue&type=template&id=9052789a"
import script from "./PictureView.vue?vue&type=script&lang=js"
export * from "./PictureView.vue?vue&type=script&lang=js"
import style0 from "./PictureView.vue?vue&type=style&index=0&id=9052789a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports